import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BaseHttpService } from './base-http.service';
import { environment } from '../../environments/environment';
import { Driver } from './driver.service';

export type DriverDisplayMode = 'NAME_AND_SURNAME' | 'DRIVER_CODE' | string;

export interface ClientConfiguration {
  driverDisplayMode?: DriverDisplayMode;
}

@Injectable({
  providedIn: 'root',
})
export class ClientConfigurationService extends BaseHttpService {
  private readonly apiUrl = environment.trackycontrol;
  private readonly config$ = new BehaviorSubject<ClientConfiguration | null>(null);

  constructor(http: HttpClient) {
    super(http);
  }

  /** Emesso dopo ogni caricamento (successo o fallimento con null). */
  get configurationChanges(): Observable<ClientConfiguration | null> {
    return this.config$.asObservable();
  }

  get driverDisplayMode(): DriverDisplayMode {
    return this.config$.value?.driverDisplayMode ?? 'NAME_AND_SURNAME';
  }

  /**
   * GET /api/clients/configuration/{targa}
   */
  loadConfiguration(targa: string): Observable<ClientConfiguration | null> {
    const plate = (targa || '').trim().toUpperCase();
    if (!plate) {
      this.config$.next(null);
      return of(null);
    }
    const url = `${this.apiUrl}/api/clients/configuration/${encodeURIComponent(plate)}`;
    return this.get<ClientConfiguration>(url).pipe(
      tap((cfg) => this.config$.next(cfg ?? null)),
      catchError(() => {
        this.config$.next(null);
        return of(null);
      })
    );
  }

  getDriverSelectLabel(driver: Driver): string {
    if (this.driverDisplayMode === 'DRIVER_CODE') {
      const code = (driver.driverCardNumber ?? '').toString().trim();
      if (code) {
        return code;
      }
    } else {
      return this.formatNameSurname(driver);
    }

    return ''
  }

  private formatNameSurname(driver: Driver): string {
    const name = driver.name || '';
    const surname = driver.surname || '';
    if (!name && !surname) {
      return '';
    }
    return `${surname} ${name}`.trim();
  }
}
